import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block truncate" }
const _hoisted_2 = { class: "absolute flex items-center inset-y-0 right-0 pr-2" }
const _hoisted_3 = { class: "flex flex-row" }

import { ref, watch } from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownComponent',
  props: {
  options: Array,
  modelValue: Object,
  isDisable: { type: Boolean, default: false },
},
  emits: ["onOptionSelected"],
  setup(__props) {

const props = __props

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const HomeIcon = require("@heroicons/vue/solid/HomeIcon");


const route = useRoute();


const optionModel = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newValue) => {
      optionModel.value = newValue;
    },
    { deep: true }
);




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Listbox), {
    class: "relative w-44",
    as: "div",
    modelValue: optionModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((optionModel).value = $event)),
    disabled: __props.isDisable
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ListboxButton), {
        class: _normalizeClass([
        'relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-pointer focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500',
        __props.isDisable ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-900'
      ])
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(__props.modelValue?.label), 1),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_unref(SelectorIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(ListboxOptions), { class: "absolute w-full max-h-60 mt-1 py-1 z-10 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, i) => {
            return (_openBlock(), _createBlock(_unref(ListboxOption), {
              as: "template",
              key: i,
              value: option,
              onClick: ($event: any) => (_ctx.$emit('onOptionSelected', option))
            }, {
              default: _withCtx(() => [
                _createElementVNode("li", {
                  class: _normalizeClass(["relative py-2 px-3 hover:text-white hover:bg-indigo-600 text-gray-900 cursor-pointer select-none", [
            __props.modelValue == option
              ? 'font-bold text-indigo-600 hover:text-white'
              : 'font-normal',
          ]])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(option.label), 1),
                    (__props.modelValue == option)
                      ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                          key: 0,
                          class: "h-5 w-5 ml-auto",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ]),
              _: 2
            }, 1032, ["value", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "disabled"]))
}
}

})